export const environment = {
  production: true,
  ruta: "https://api.ieeg.mx/SEOEPrueba/",
  version: "capacitación-1.4.1",
};

